/**
 * Slack channel deep links.
 *
 * `app_redirect` is the workspace-agnostic redirect that opens the Slack desktop
 * app (or web client) directly to a channel by its id — no team id required, and
 * it works for every user regardless of which workspace client they have open.
 * See https://api.slack.com/reference/deep-linking#open_a_channel
 */

/**
 * Build a deep link that opens the given Slack channel in the user's Slack app.
 * Returns null when the channel id is empty/blank so callers can branch cleanly
 * (e.g. show a "no channel set" message instead of opening a dead tab).
 */
export function buildSlackChannelUrl(
  channelId: string | null | undefined
): string | null {
  const id = (channelId ?? "").trim();
  if (id.length === 0) return null;
  return `https://slack.com/app_redirect?channel=${encodeURIComponent(id)}`;
}
